import React from 'react'
import { Box, Text } from '@chakra-ui/react'

export type EmptyResultsProps = {
  text: string
  isShowed: boolean
}

export const EmptyResults = ({ text, isShowed }: EmptyResultsProps) => {
  return !isShowed ? (
    <></>
  ) : (
    <Box
      display={'flex'}
      flexDirection={'column'}
      width={'100%'}
      padding={'15px'}
      borderRadius={'8px'}
      gap={'10px'}
      bg={'#171717'}
    >
      <Text
        fontSize={'20px'}
        fontWeight={500}
        color={'#a2a2a2'}
        textAlign={'center'}
        p={'10px 20px'}
      >
        {text}
      </Text>
    </Box>
  )
}
